import styled from 'styled-components';
import appTheme from '../../themes/Theme';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${appTheme.textColor};
  background-color: ${appTheme.backgroundColor};
  min-height: calc(100vh - 233px);
`;

export const StyledHeader = styled.h2`
  text-align: center;
`;

export const StyledScript = styled.div`
  padding: 0.3rem;
  border: 2px solid #441dee;
  border-radius: 5px;
  word-wrap: break-word;
  font-size: 24px;
  font-family: Roboto;
  font-weight: 500;
  color: ${appTheme.textColor};
`

export const StyledButton = withStyles((theme) => ({
  root: {
    borderRadius: 3,
    height: 40,
    width: 120,
    margin: 10,
  },
}))(Button);

export const StyledFooter = styled.div`
  margin-top: auto;
  text-align: center;
  font-size: 12px;
`
